import React, { FunctionComponent } from 'react';

const NotFound: FunctionComponent = () => <div>Not Found</div>;
export default NotFound;
